import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Box, Button, rem, Text } from '@bonusly/design-system';

import { Budget } from '../../lib/entities/budget';
import { useBalanceData } from './hooks/use-balance-data';

interface AmountBalanceProps {
	allowanceBoostId?: string;
	budget: Budget;
}

export const AmountBalance: FC<AmountBalanceProps> = ({ allowanceBoostId = '', budget }) => {
	const { t } = useTranslation('components');
	const { description } = useBalanceData();

	if (!budget.data.balance) {
		return (
			<Box textAlign="center" maxW={rem(240)}>
				<Text color="gray.900" fontSize="md" fontWeight="medium" mb={2}>
					{t('rich_media.amount.no_balance_title', {
						currency: budget.data.display.plural,
					})}
				</Text>

				<Text color="gray.700" fontSize="sm" fontWeight="normal" mb={4}>
					{description}
				</Text>

				<Button as={Link} to={`/rewards/${allowanceBoostId}`} w="full">
					{t('rich_media.amount.add_to_balance_button')}
				</Button>
			</Box>
		);
	}

	return (
		<Text fontSize="md" fontWeight={400}>
			{t('rich_media.amount.balance_available_to_give', {
				amount: budget.formattedBalance(),
			})}
		</Text>
	);
};
